import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/sections/HeroSection';
import WhyGoldSection from '../components/sections/WhyGoldSection';
import PerformanceChart from '../components/sections/PerformanceChart';
import GoldCalculator from '../components/sections/GoldCalculator';
import SourcesSection from '../components/sections/SourcesSection';
import GoldNewsSection from '../components/sections/GoldNewsSection';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <GoldCalculator />
        <WhyGoldSection />
        <PerformanceChart />
        <SourcesSection />
        <GoldNewsSection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
